import React from 'react';
import { Button, BackButton, ResultValue, PrintButton } from '../Components/Simple';
import {
  BasicInformation, ClaimDetails, FactorAndAdjustments, IPPSPayment,
  PricingErrors, StandardPayment, SiteNeutralPayment
} from '../Components/Combined/Results';
import { LTCH as modelType } from '../Constants/modelTypes';
import { formatStringAsCurrency, formatDateString } from '../Utils/stringUtils';
import { API_DATE_STRING_FORMAT, DATE_STRING_FORMAT } from '../Constants/stringFormats';
import { useNavigate, useLocation } from 'react-router-dom';
import DRGResults from '../Components/Results/DRGResults';
import Protect from '../Components/Combined/Protect';
import { HIDE } from '../Constants/protectionBehaviors';
import { EOB_VIEW } from '../Constants/moduleNames';
import { enableEOB } from '../Utils/features';

export default function LTCHResult() {
  const location = useLocation();
  const navigate = useNavigate();
  const { result, fiscalYear, drgServiceMode } = location.state;

  const processedDate = new Date();

  const handleNavigateToEOBGenerator = () => {
    const fromDate = formatDateString(result.fromDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)
    const toDate = fromDate && formatDateString(result.toDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)
    navigate('/EOB', {
      state: {
        processedDate,
        pricerType: modelType,
        lines: [{
          dateOfService: toDate && `${fromDate} - ${toDate}`,
          serviceCode: "",
          serviceDescription: "IP Hospital Services",
          qty: "",
          billedAmount: parseFloat(result.totalBilled) || 0,
          allowedAmount: parseFloat(result.medicareAllowed) || 0,
          initialMaxShiftAmount: 0
        }]
      }
    });
  };

  return (<div className="py-2">
    <div className="row g-0 sticky top border-bottom">
      <div className="row justify-content-between g-0">
        <div className="col-auto">
          <PrintButton />
        </div>
        <div className="col-auto">
          <Protect module={EOB_VIEW} behavior={HIDE} >
            {enableEOB && <Button className="btn btn-success" onClick={handleNavigateToEOBGenerator} text="Generate EOB" />}
          </Protect>
        </div>
        <div className="col-auto">
          <BackButton />
        </div>
      </div>
      <div className="row my-2 g-0">
        <div className="col">
          <h2>LTCH Pricer - Pricing Outputs</h2>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <ResultValue label="Medicare Allowed Amount" value={formatStringAsCurrency(result.medicareAllowed)} labelClassName="fs-4 fw-500" valueClassName="fs-4 fw-500" />
      </div>
    </div>
    <PricingErrors result={result} totalMedicareAllowed={result.medicareAllowed} />
    <div className="row my-2">
      <div className="col-md-6">
        <BasicInformation fiscalYear={fiscalYear} result={result} model={modelType} processedDate={processedDate} />
      </div>
    </div>
    <div className="row my-2">
      <div className="col-md">
        <ClaimDetails result={result} model={modelType} />
      </div>
      <div className="col-md">
        <FactorAndAdjustments result={result} model={modelType} />
      </div>
    </div>
    <h3>Pricing Amounts</h3>
    <div className="row my-2">
      <div className="col-md-6">
        <StandardPayment result={result} />
      </div>
      <div className="col-md-6">
        <SiteNeutralPayment result={result} />
      </div>
    </div>
    <div className="row my-2">
      <div className="col-md-6">
        <IPPSPayment result={result} />
      </div>
      <div className="col-md-6">
        <p><span className="text-decoration-underline">Note:</span> Final payment may not add up to the sum of the pricing amounts. Final Medicare Allowed is based on the appropriate method. Site neutral blend percent is the weight applied to the site neutral payment when applicable, the remaining weight applies to the standard payment.</p>
      </div>
    </div>
    <DRGResults result={result} serviceMode={drgServiceMode} />
  </div>
  );
}
